import { combineReducers } from 'redux';

import heatmap from './heatmap';

export default combineReducers({
  heatmap,
});
